// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*

Content styling

*/

body {
  color: #212121;
}

/* content field */
.ant-layout-content div.Paper {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
  padding: 24px;
  background: #fff;
  min-height: 360px;
}
.launchScreen .dialog {
  padding: 6px 50px !important;
}
.contentColumn {
  min-height: 100vh !important;
  display: grid;
  background-color: #fcfcfc;
  overflow: hidden;
}
.contentColumn .stretcher {
  display: grid;
  grid-template-rows: auto minmax(min-content, 1fr) auto;
}

.ant-layout {
  background-color: transparent;
}

.ant-layout-content {
  padding: 32px 0px;
  background-color: #fcfcfc;
  max-width: 100vw;
  min-height: calc(100vh - 50px) !important;
}

.hide-content-padding {
  padding: 0 !important;
}

.ant-layout-content.remove-padding {
  padding: 0;
}

.ant-layout-content.less-padding {
  padding: 30px 0px;
}

.DashboardContainer-container-4 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* content field */
.ant-layout-content div.Paper.Wide {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
  padding: 30px;
  margin: auto;
  max-width: 100%;
}

.ant-layout-content div.Paper.Middle {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
  padding: 30px;
  margin: auto;
  max-width: 67%;
}
.ant-layout-content div.Paper.Narrow {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
  padding: 30px;
  margin: auto;
  max-width: 480px;
}

.job-set .ant-modal-content .ant-modal-body,
.skill-set .ant-modal-content .ant-modal-body {
  max-height: 600px;
  overflow-y: auto;
}

.moreTestTable .ant-table .ant-table-thead > tr > th {
  padding: 16px 4px;
}

.contentColumn .stretcher.leftDrawerCollapsed {
  display: block;
}

/* --- Updates made along with "New user profile" project, 2019/08/02 - 2019-08/21 */

.Paper.Profile-Box {
  min-height: auto !important;
  margin-bottom: 24px;
  position: relative;
}
.Paper.Card {
  min-height: auto !important;
  margin-bottom: 0;
  position: relative;
}

.Paper .title-1 {
  font-weight: 500;
  font-size: 20px;
  line-height: 26px;
  text-align: left;
  color: #212121;
}

.Paper .content {
  padding-top: 40px;
  padding-bottom: 40px;
}

.Paper .content.centered {
  text-align: center;
}

.profile-img-holder {
  margin-bottom: 32px;
  position: relative;
}

.profile-img-avatar-container {
  display: inline-block;
  position: relative;
}

.profile-img-avatar-container button.edit {
  top: -20px;
  right: -20px;
  border: none;
  background: transparent;
  opacity: 0;
  transition: 0.5s opacity ease;
}

.profile-img-avatar-container button.edit:hover {
  background: transparent;
}

.profile-img-avatar-container:hover button.edit {
  opacity: 1;
}

.profile-img-loading {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  opacity: 1;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3;
  font-size: 2em;
}

.profile-img {
  width: 96px;
  height: 96px;
  margin: 0 auto;
  border-radius: 100%;
  cursor: pointer;
}

.profile-img-edit-menu {
  padding: 0;
  margin: 0;
}

.profile-img-edit-menu li {
  width: 100%;
  padding: 5px 10px;
  list-style: none;
  cursor: pointer;
}

.profile-img-edit-menu li:hover {
  background: rgba(24, 144, 255, 0.1);
}

.profile-img-edit-menu li .anticon {
  margin-right: 10px;
}

.user-fullname {
    font-weight:  600;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  color: #444444;
  margin-bottom: 16px;
}

.user-title {
  font-weight:  600;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: #666666;
  margin-bottom: 8px;
}

.user-subtitle {
  font-weight:  300;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #888888;
  margin-bottom: 8px;
}

.user-address {
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #666666;
}
.user-address span.txt {
  margin-left: 7px;
}

.user-worktime {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #666666;
}

.user-linkedin {
  font-weight:  300;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  margin-top: 8px;
  color: #666666;
}

.user-github {
  font-weight:  300;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  margin-top: 8px;
  color: #666666;
}

.user-worktime span.txt {
  margin-left: 7px;
}

.user-working-hours {
  margin-bottom: 10px;
}

.input-name .user-timezone,
.input-name .pacific-timezone {
  font-size: 11px;
  display: block;
  opacity: 0.6;
}

.user-time-overlap {
  font-size: 0.8em;
}

.user-time-overlap .good-overlap {
  color: #28a745;
}

.user-time-overlap .bad-overlap {
  color: #dc3545;
}

.user-time-overlap-popover {
  font-size: 12px;
  line-height: 2em;
}

.upload-file-btn-holder {
  margin-top: 20px;
}

.upload-file-btn-holder .upload-file-name {
  margin-top: 10px;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #888;
}

.upload-file-btn-holder .upload-file-name a {
  color: inherit;
  font-size: 13px;
}

.experience,
.projects,
.education,
.cert-aw,
.publication {
  position: relative;
  display: flex;
  margin-bottom: 30px;
  align-items: center;
}

.experience:last-child,
.projects:last-child,
.education:last-child,
.cert-aw:last-child,
.publication:last-child {
  margin-bottom: 0;
}

.experience .e-date-holder,
.projects .e-date-holder,
.education .e-date-holder,
.cert-aw .e-date-holder,
.publication .e-date-holder {
  /*width: 15%;
        min-width: 80px;
        display: inline-block;*/
  height: auto;
  min-height: 100%;
  /*height: calc(100% - 40px - 40px);*/
  min-width: 63px;
}

.experience .e-date-holder .e-date-end,
.projects .e-date-holder .e-date-end,
.education .e-date-holder .e-date-end,
.cert-aw .e-date-holder .e-date-end,
.publication .e-date-holder .e-date-end {
}

.experience .e-date-holder .e-date-start,
.projects .e-date-holder .e-date-start,
.education.e-date-holder .e-date-start,
.cert-aw .e-date-holder .e-date-start,
.publication .e-date-holder .e-date-start {
}

.experience .e-date-holder .e-date-separator,
.projects .e-date-holder .e-date-separator,
.education .e-date-holder .e-date-separator,
.cert-aw .e-date-holder .e-date-separator,
.publication .e-date-holder .e-date-separator {
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  width: 1px;
  height: 100%; /* IE support */
  height: calc(100% - 120px);
  min-height: 10px;
  background-color: rgb(230, 230, 230);
}

.experience .e-date-holder .e-date-month,
.projects .e-date-holder .e-date-month,
.education .e-date-holder .e-date-month,
.cert-aw .e-date-holder .e-date-month,
.publication .e-date-holder .e-date-month {
    font-weight:  600;
  font-size: 12px;
  line-height: 16px;
  text-align: left;
  color: #888888;
}

.experience .e-date-holder .e-date-year,
.projects .e-date-holder .e-date-year,
.education .e-date-holder .e-date-year,
.cert-aw .e-date-holder .e-date-year,
.publication .e-date-holder .e-date-year {
    font-weight:  600;
  font-size: 16px;
  line-height: 21px;
  text-align: left;
  color: #888888;
}

.experience .e-content-holder,
.projects .e-content-holder,
.education .e-content-holder,
.cert-aw .e-content-holder,
.publication .e-content-holder {
  /*width: 85%;*/
  display: inline-block;
  margin-left: 20px;
}

.experience .e-title-holder,
.projects .e-title-holder,
.education .e-title-holder,
.cert-aw .e-title-holder,
.publication .e-title-holder {
}

.experience .e-title,
.projects .e-title,
.education .e-title,
.cert-aw .e-title,
.publication .e-title {
    font-weight:  600;
  font-size: 14px;
  line-height: 19px;
  text-align: left;
  color: #212121;
  margin-bottom: 2px;
}

.experience .e-subtitle,
.projects .e-subtitle,
.education .e-subtitle,
.cert-aw .e-subtitle,
.publication .e-subtitle {
  font-weight:  300;
  font-size: 12px;
  line-height: 16px;
  text-align: left;
  color: #888888;
  margin-bottom: 2px;
}

.experience .e-details-holder,
.projects .e-details-holder {
  font-weight:  300;
  font-size: 14px;
  line-height: 21px;
  text-align: left;
  color: #212121;
  margin-bottom: 5px;
}

.experience .e-details-holder ul,
.projects .e-details-holder ul {
  padding: 0;
  padding-left: 20px;
  padding-top: 20px;
  margin: 0;
}

.experience .e-details-holder ul li,
.projects .e-details-holder ul li {
  font-weight:  300;
  font-size: 14px;
  line-height: 21px;
  text-align: left;
  color: #212121;
  margin-bottom: 5px;
}

.Paper .experience,
.Paper .projects {
  padding-right: 20px;
}

.experience .edit-btn,
.projects .edit-btn {
  position: absolute;
  top: 0;
  right: 24px;
  opacity: 0;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.cert-aw .edit-btn,
.publication .edit-btn {
  position: absolute;
  top: -18px;
  right: 24px;
  opacity: 0;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.experience .edit-btn,
.projects .edit-btn,
.cert-aw .edit-btn,
.publication .edit-btn {
  opacity: 0;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.experience:hover .edit-btn,
.projects:hover .edit-btn,
.cert-aw:hover .edit-btn,
.publication:hover .edit-btn {
  opacity: 1;
  right: 39px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.experience .delete-btn,
.projects .delete-btn {
  position: absolute;
  top: 0;
  right: -28px;
  opacity: 0;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.cert-aw .delete-btn,
.publication .delete-btn {
  position: absolute;
  top: -18px;
  right: -28px;
  opacity: 0;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.experience .delete-btn,
.projects .delete-btn,
.cert-aw .delete-btn,
.publication .delete-btn {
  opacity: 0;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.experience:hover .delete-btn,
.projects:hover .delete-btn,
.cert-aw:hover .delete-btn,
.publication:hover .delete-btn {
  opacity: 1;
  right: -13px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

table.skills-table,
table.jobs-table {
  width: 100%;
  border: none;
}

table.skills-table thead,
table.jobs-table thead {
}

table.skills-table {
  margin-top: 30px;
}

button.ant-btn.ant-btn-primary[disabled] {
  background-color: #ededed;
  color: #999999;
}

.Paper .skills-bottom .ant-typography {
  display: block;
}

table.skills-table thead tr th,
table.jobs-table thead tr th {
    font-weight:  600;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  text-align: left;
  line-height: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e8e8e8;
}

table.skills-table tbody tr td {
  vertical-align: top;
}

table.skills-table .ant-form-item {
  margin-bottom: 0 !important;
}

.skills-table tbody tr td i.anticon-delete {
  color: red;
  font-size: 16px;
  margin: 12px 0px;
}

table.skills-table thead tr th:nth-child(1) {
  max-width: 30%;
  min-width: 30%;
  width: 30% !important;
  text-align: left;
}
table.skills-table thead tr th:nth-child(2) {
  max-width: 25%;
  min-width: 25%;
  width: 25% !important;
  text-align: left;
  padding-left: 10px;
}
table.skills-table thead tr th:nth-child(3) {
  max-width: 25%;
  min-width: 25%;
  width: 25% !important;
  text-align: left;
  padding-left: 10px;
}
table.skills-table thead tr th:nth-child(4) {
  text-align: right;
}

table.jobs-table thead tr th:nth-child(1) {
  text-align: left;
  max-width: 80px;
  word-wrap: break-word;
}

table.jobs-table thead tr th:nth-child(2) {
  text-align: left;
  padding-left: 10px;
}

table.jobs-table thead tr th:nth-child(3) {
  text-align: right;
}

table.skills-table tbody,
table.jobs-table tbody {
}

table.skills-table tbody tr,
table.jobs-table tbody tr {
  background-color: transparent;
}

table.skills-table tbody tr:hover td .button-holder {
  opacity: 1;
  right: 15px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

table.skills-table tbody tr td,
table.jobs-table tbody tr td {
  font-weight:  300;
  font-size: 14px;
  color: #212121;
  text-align: left;
  line-height: 22px;
  border-bottom: 1px solid #e8e8e8;
  padding: 13px 0;
}
table.skills-table tbody tr td:nth-child(1),
table.jobs-table tbody tr td:nth-child(1) {
  text-align: left;
  max-width: 80px;
  word-wrap: break-word;
}
table.skills-table tbody tr td:nth-child(2),
table.jobs-table tbody tr td:nth-child(2) {
  text-align: left;
  padding-left: 10px;
}
table.skills-table tbody tr td:nth-child(3) {
  text-align: left;
  padding-left: 10px;
}
table.jobs-table tbody tr td:nth-child(3) {
  text-align: right;
  position: relative;
}
table.skills-table tbody tr td:nth-child(4) {
  text-align: right;
  position: relative;
}

table.skills-table tbody tr td .button-holder {
  width: 110px;
  position: absolute;
  top: 0;
  right: -2px;
  opacity: 0;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

table.skills-table tbody tr td .button-holder button {
  /*width: 35px !important;
            height: 35px !important;*/
}
table.skills-table tbody tr td .button-holder button:nth-child(1) {
  margin-right: 7px;
}

.ant-select-selection:hover {
  border-color: #888888 !important;
  box-shadow: 0 1px 2px rgba(136, 136, 136, 0.16) !important;
}
.ant-select-selection:focus {
  border: 1px solid #42a5f5 !important;
  box-shadow: 0 1px 2px rgba(66, 165, 245, 0.2) !important;
}

button.edit {
  position: absolute;
  top: 12px;
  right: 12px;
}

.select-search-holder {
  position: relative;
  width: 100%;
}

.select-search-holder {
  position: relative;
  width: 100%;
}

.select-search-holder .material-icons {
  position: absolute;
  top: 7px;
  left: 5px;
  z-index: 99;
}

.select-search-holder .ant-select-selection {
  padding-left: 20px;
}

.select-search-holder .ant-select-selection .ant-select-arrow {
  display: none;
}

.ant-select.error .ant-select-selection {
  background-color: #ffffff;
  border: 1px solid #ef5350 !important;
  box-shadow: 0 0 0 transparent !important;
}

.modal-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(245, 245, 245, 0.55);
  z-index: 200;
}

.modal-wrap .modal-wrap-inner {
  position: relative;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

.modal-wrap .modal-wrap-inner .modal-box {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 70%;
  min-width: 300px;
  max-width: 750px;
  height: auto;
  min-height: 300px;
  margin: 0 auto;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.08);
}

.modal-wrap .modal-wrap-inner .modal-box .modal-box-close {
  position: relative;
}

.modal-wrap .modal-wrap-inner .modal-box .modal-box-close button {
  position: absolute;
  top: 32px;
  right: 32px;
}

.modal-wrap .modal-wrap-inner .modal-box .modal-header {
}

.modal-wrap .modal-wrap-inner .modal-box .modal-header .modal-title {
    font-weight:  600;
  font-size: 28px;
  color: #212121;
  text-align: left;
  line-height: 37px;
  margin: 48px 32px 32px 32px;
}

.modal-wrap .modal-wrap-inner .modal-box .modal-body {
  padding: 0 32px;
}

.modal-body-row,
.modal-wrap .modal-wrap-inner .modal-box .modal-body .modal-body-row {
  margin-bottom: 20px;
}

.modal-body-row .modal-body-col-5050 {
  width: 50%;
  display: inline-block;
}
.modal-body-row .modal-body-col-5050:nth-child(1) {
  padding-right: 10px;
}
.modal-body-row .modal-body-col-5050:nth-child(2) {
  padding-left: 10px;
}

.modal-body-row .modal-body-col-5050.multiple-selects .ant-select {
  margin-bottom: 7px;
}

.modal-body-row .modal-body-col-75 {
  width: 75%;
  display: inline-block;
  padding-right: 10px;
}
.modal-body-row .modal-body-col-25 {
  width: 25%;
  display: inline-block;
}

.modal-wrap .modal-wrap-inner .modal-box .modal-footer {
  display: flex;
  justify-content: right;
  padding: 32px 32px 24px 32px;
}

.modal-wrap .modal-wrap-inner .modal-box .modal-footer button:not(:last-child) {
  margin-right: 8px;
}

@media (max-width: 1023px) {
  .profile-section {
    justify-content: center;
    display: flex;
    flex-direction: column;
  }

  .modal-body-row .modal-body-col-5050 {
    width: 100%;
    display: block;
    margin: 15px 0px;
  }

  .modal-body-row {
    margin-bottom: 0px;
  }
  .modal-body-row .modal-body-col-5050:nth-child(1) {
    padding-right: 0px;
  }
  .modal-body-row .modal-body-col-5050:nth-child(2) {
    padding-left: 0px;
  }

  .ant-layout .ant-layout-content {
    padding: 120px 10px 20px;
    margin: 0 !important;
    display: flex;
    /* justify-content: center; */
    max-width: 100vw !important;
  }

  .detailsSection {
    width: 90vw !important;
  }

  .title-1 {
    font-size: 17px !important;
  }
  .ant-layout-content.remove-padding {
    padding: 64px 0 0 0 !important;
    margin: 0 !important;
  }

  .ant-layout-content.less-padding {
    padding: 100px 10px !important;
    margin: 0 !important;
  }
}

@media (max-width: 744px) {
 .ant-layout .ant-layout-content {
    padding: 80px 10px 20px;
  }
}

/*.ant-modal-wrap, .ant-modal-wrap > *{
    transition: all 0.2s;
  }
  
  .ant-modal-wrap, .ant-modal-wrap > *{
    transition: all 0.2s;
  }*/

.present-date {
  /*display: none;*/
    font-weight:  600;
  font-size: 16px;
  line-height: 21px;
  text-align: left;
  color: #888888;
}
.present-date.visible {
  display: block;
}

.end-date-selects {
}
.end-date-selects.hidden {
  display: none;
}

.ant-btn.ant-btn-danger {
  color: #fff;
  background-color: #ff4d4f;
  border-color: #ff4d4f;
}
.ant-btn.ant-btn-danger:hover,
.ant-btn.ant-btn-danger:focus {
  color: #fff !important;
  background-color: #ff7875 !important;
  border-color: #ff7875;
}
.ant-btn.ant-btn-danger:active {
  color: #fff !important;
  background-color: #d9363e !important;
  border-color: #d9363e;
}

.is-white-c {
  color: #ffffff;
}

.is-visible {
  display: block;
}
.is-hidden {
  display: none;
}
.is-block {
  display: block;
}
.is-inlineb {
  display: inline-block;
}
.is-inline {
  display: inline;
}

.is-left {
  float: left;
}
.is-right {
  float: right;
}

.is-flex {
  display: flex;
}

.flex-center-content {
  display: flex;
  align-items: center;
}

.info-btn {
  margin-left: 7px;
}

.ant-alert {
  margin-bottom: 16px;
}

/* DEFAULT CHECKBOX */

.ant-checkbox-wrapper {
  margin-bottom: 4px;
}

.ant-checkbox {
  position: relative;
  z-index: 2 !important;
  width: 40px;
  height: 40px;
  border-radius: 100%;
}

.ant-checkbox::after {
  top: 11px;
  left: 11px;
}

.ant-checkbox input.ant-checkbox-input {
  z-index: 0 !important;
}

.ant-checkbox .ant-checkbox-inner {
  top: 11px;
  left: 11px;
  width: 18px;
  height: 18px;
  border: 2px solid #888888 !important;
  background-color: transparent;
}

/* on Focus */

.ant-checkbox-wrapper:focus-within .ant-checkbox {
  /*background-color: rgba(68, 68, 68, 0.12) !important;*/
  background-color: transparent;
}
.ant-checkbox:focus-within,
.ant-checkbox.ant-checkbox-checked:focus-within {
  /*background-color: rgba(68, 68, 68, 0.12) !important;*/
  background-color: transparent;
}

/*
  How Ant handles focus and active state
  -
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    background-color: rgba(68, 68, 68, 0.12) !important;
  -
  We will have to make something around this styling logic to get our design
  The problem here is that Ant puts focus on input and styles alement next to it,
  but we want to style parent element.
  }*/

.ant-checkbox-wrapper:focus .ant-checkbox-inner {
  border: 2px solid #888888;
}

/* on Click */

.ant-checkbox-wrapper:active .ant-checkbox,
.ant-checkbox:active,
.ant-checkbox-wrapper .ant-checkbox.ant-checkbox-checked:active {
  background-color: rgba(68, 68, 68, 0.18) !important;
}

.ant-checkbox-wrapper:active .ant-checkbox-inner {
  border: 2px solid #888888;
}

/* Checked */

.ant-checkbox.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #444444;
  border: 2px solid #444444 !important;
}

.ant-checkbox.ant-checkbox-checked::after {
  border: none;
  animation: none;
}

/* Hover */

.ant-checkbox:hover {
  background-color: rgba(68, 68, 68, 0.06) !important;
}

.ant-checkbox:hover .ant-checkbox-inner {
  /*border: 2px solid #888888 !important;*/
}

/* Disabled */

.ant-checkbox-wrapper-disabled .ant-checkbox-disabled {
  background-color: transparent !important;
}

.ant-checkbox-wrapper-disabled
  .ant-checkbox-disabled.ant-checkbox-checked
  .ant-checkbox-inner {
  background-color: #aaaaaa !important;
  border: 2px solid #aaaaaa !important;
}

.ant-checkbox-wrapper-disabled .ant-checkbox-disabled .ant-checkbox-inner {
  border: 2px solid #aaaaaa !important;
}

.ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
  border-color: #fff !important;
}

/* INDETERMINATE */

.ant-checkbox.ant-checkbox-indeterminate {
  /*background-color: transparent !important;*/
}

/* Checked */

.ant-checkbox.ant-checkbox-indeterminate .ant-checkbox-inner {
  border: 2px solid #888888 !important;
}

.ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-checked
  .ant-checkbox-inner {
  background-color: transparent !important;
}

.ant-checkbox.ant-checkbox-indeterminate .ant-checkbox-inner::after {
  background-color: transparent;
}

.ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-checked
  .ant-checkbox-inner::after {
  background-color: #444444;
}

/* Disabled */

.ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-disabled
  .ant-checkbox-inner {
  border: 2px solid #aaaaaa !important;
}

.ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-disabled
  .ant-checkbox-inner::after {
  background-color: #aaaaaa !important;
}

.ant-checkbox-wrapper:active .ant-checkbox.ant-checkbox-disabled {
  background-color: transparent !important;
}

/* Hover */

.ant-checkbox-wrapper:hover
  .ant-checkbox-indeterminate.ant-checkbox-checked
  .ant-checkbox-inner {
  border: 2px solid #888888 !important;
}

/* WITH LABEL */

.ant-checkbox-wrapper + span,
.ant-checkbox + span {
  font-size: 14px;
  color: #888888;
  /*padding-left: 0;*/
  display: inline-block;
  vertical-align: middle;
  padding-bottom: 3px;
}

/* Disabled */

.ant-checkbox-wrapper.ant-checkbox-wrapper-disabled + span,
.ant-checkbox.ant-checkbox-disabled + span {
  color: #aaaaaa;
}

/* GROUP */

/* List checkboxes one under the other */

.cbx-list-group {
}

.cbx-list-group .ant-checkbox-group-item {
  display: block;
}

/* GROUP - indeterminate */

.group-indeterminate {
}

.group-indeterminate > .ant-checkbox-wrapper {
  margin-bottom: 10px;
}

.group-indeterminate .ant-checkbox-group {
  display: block;
  width: 100%;
  padding-left: 23px;
}

.group-indeterminate .ant-checkbox-group .ant-checkbox-group-item {
  display: block;
}

/* ANIMATION */

.ant-checkbox.ant-checkbox-checked::after {
  border: none;
  animation: none;
}

/* Ant input with prefix */

.ant-input-prefix input.ant-input {
  padding-left: 30px;
}

.ant-input-prefix input.ant-input::placeholder {
  padding-left: 30px;
}

/* AutoComplete Ant component styles */

.ant-select-auto-complete.ant-select .ant-select-selection--single {
  padding-top: 0 !important;
}

/* Ant input with prefix */

.ant-input-prefix input.ant-input {
  padding-left: 30px;
}

.ant-input-prefix input.ant-input::placeholder {
  padding-left: 30px;
}

/* Ant input with suffix */

.ant-input-affix-wrapper .ant-input-suffix {
  color: rgba(0, 0, 0, 0.25);
}

.ant-input-suffix-black .ant-input-suffix {
  color: rgba(0, 0, 0) !important;
}

.ant-input-suffix-black .ant-input-prefix {
  color: rgba(0, 0, 0) !important;
}

/* AutoComplete Ant component styles */

.ant-select-auto-complete.ant-select .ant-select-selection--single {
  padding-top: 0 !important;
}

.ant-select-auto-complete.ant-select .ant-input {
  height: 40px;
}

.ant-select.error input.ant-input {
  border-color: transparent !important;
}

.product-design {
  line-height: 1.8;
}

.product-design .list-title {
  font-weight: 500;
  margin-bottom: 7px;
}

.product-design .roman-list-style {
  list-style-type: upper-alpha;
  padding-left: 19px;
}

.product-design .allowed-types {
  font-size: 10px;
  color: #bbb;
  margin-top: 10px;
  font-weight: 500;
}

.product-design .upload-btn-holder {
  margin-top: 30px;
}

.system-design {
  line-height: 1.8;
}

.system-design .roman-list-style {
  list-style-type: upper-alpha;
  padding-left: 19px;
}

.system-design .list-title {
  font-weight: 500;
  margin-bottom: 7px;
}

.system-design .allowed-types {
  font-size: 10px;
  color: #bbb;
  margin-top: 10px;
  font-weight: 500;
}

.system-design .upload-btn-holder {
  margin-top: 30px;
}

.skill-user-guide {
  padding-top: 10px;
  color: orange;
  margin: 0px;
  font-weight: 500;
}

/* Dropdown customization */
/* Only override with more specific class, otherwise let it choose default width */
.ant-select-dropdown.override-width {
  width: 250px !important;
}

.profile-section {
  padding-top: 30px;
  /* padding-bottom: 30px; */
}

.profile-container {
  max-width: 800px;
  margin: 0px auto;
}

.experience .e-details-label {
  padding-top: 10px;
  padding-bottom: 5px;
  text-decoration: underline;
}

/* Default input - placeholder */
.ant-input::-webkit-input-placeholder {
  color: #959595 !important;
  opacity: 1 !important;
}

.ant-input::-moz-placeholder {
  color: #959595 !important;
  opacity: 1 !important;
}

.ant-input::-ms-input-placeholder {
  color: #959595 !important;
  opacity: 1 !important;
}

.ant-input::placeholder {
  color: #959595 !important;
  opacity: 1 !important;
}

.bottom-padded {
  padding-bottom: 80px !important;
}

.promptMessage {
  font-size: 14px;
  color: grey;
}

.deleteSkill {
  padding-top: 22px !important;
  text-align: right !important;
  cursor: pointer !important;
}

.left-aligned {
  text-align: left !important;
}

.ant-radio-wrapper {
  display: flex !important;
}

.ql-syntax {
  background-color: #fafafa !important;
  color: #426bb9 !important;
}

/* Set content font-families */
.ql-font-Gordita {
  font-family: "Gordita";
}
.ql-font-Menlo {
  font-family: "Menlo";
}
.ql-font-Ringside {
  font-family: "Ringside";
}
.ql-font-Ginto {
  font-family: "Ginto";
}


.vetsmithContentColumn {
  background: #F8F8F8 !important;
}


.vetsmithContentColumn .ant-layout-content {
  padding: 0;
  background: #F8F8F8;
}

.vetsmithContentColumn .ant-layout-content:has(.ant-spin) {
  justify-content: center;
}

.vetsmithContentColumn .turing-footer {
  background: #F8F8F8 !important;
}

.navbar-padding {
  padding: 50px 0;
}`, "",{"version":3,"sources":["webpack://./src/v3/assets/css/Content.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sDAAsD;AACxD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,0CAA0C;EAC1C,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;AACA;EACE,0CAA0C;EAC1C,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,oFAAoF;;AAEpF;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,oCAAoC;EACpC,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;IACI,iBAAiB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;EAKE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;;;;;EAKE;;+BAE6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;;;;;AAKA;;AAEA;;;;;AAKA;;AAEA;;;;;EAKE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,YAAY,EAAE,eAAe;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;;;;;IAKI,iBAAiB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;IAKI,iBAAiB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;;;;AAKA;;AAEA;;;;;IAKI,iBAAiB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;;EAKE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;;;;EAIE,UAAU;EACV,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;;;;EAIE,UAAU;EACV,WAAW;EACX,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,UAAU;EACV,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;;;;EAIE,UAAU;EACV,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;;;;EAIE,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;AAEA;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;IAEI,iBAAiB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;AAEA;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE;qCACmC;AACrC;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,0DAA0D;AAC5D;AACA;EACE,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;AACA;;AAEA;IACI,iBAAiB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;IACvB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,aAAa;IACb,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;IAC9B,oBAAoB;EACtB;AACF;;AAEA;CACC;IACG,uBAAuB;EACzB;AACF;;AAEA;;;;;;IAMI;;AAEJ;EACE,iBAAiB;IACf,iBAAiB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;AACA;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,sBAAsB;EACtB,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;;AAErB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA,aAAa;;AAEb;EACE,uDAAuD;EACvD,6BAA6B;AAC/B;AACA;;EAEE,uDAAuD;EACvD,6BAA6B;AAC/B;;AAEA;;;;;;;;;IASI;;AAEJ;EACE,yBAAyB;AAC3B;;AAEA,aAAa;;AAEb;;;EAGE,mDAAmD;AACrD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,YAAY;;AAEZ;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,UAAU;;AAEV;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,aAAa;;AAEb;EACE,wCAAwC;AAC1C;;AAEA;;;EAGE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,kBAAkB;;AAElB;EACE,4CAA4C;AAC9C;;AAEA,YAAY;;AAEZ;EACE,oCAAoC;AACtC;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,aAAa;;AAEb;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,UAAU;;AAEV;;;EAGE,oCAAoC;AACtC;;AAEA,eAAe;;AAEf;;EAEE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,aAAa;;AAEb;;EAEE,cAAc;AAChB;;AAEA,UAAU;;AAEV,wCAAwC;;AAExC;AACA;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;;AAE1B;AACA;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;;AAEd;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,0BAA0B;;AAE1B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sCAAsC;;AAEtC;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;;AAE1B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,0BAA0B;;AAE1B;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,sCAAsC;;AAEtC;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B,kFAAkF;AAClF;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;;;AAGA;EACE,8BAA8B;AAChC;;;AAGA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/*\n\nContent styling\n\n*/\n\nbody {\n  color: #212121;\n}\n\n/* content field */\n.ant-layout-content div.Paper {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);\n  padding: 24px;\n  background: #fff;\n  min-height: 360px;\n}\n.launchScreen .dialog {\n  padding: 6px 50px !important;\n}\n.contentColumn {\n  min-height: 100vh !important;\n  display: grid;\n  background-color: #fcfcfc;\n  overflow: hidden;\n}\n.contentColumn .stretcher {\n  display: grid;\n  grid-template-rows: auto minmax(min-content, 1fr) auto;\n}\n\n.ant-layout {\n  background-color: transparent;\n}\n\n.ant-layout-content {\n  padding: 32px 0px;\n  background-color: #fcfcfc;\n  max-width: 100vw;\n  min-height: calc(100vh - 50px) !important;\n}\n\n.hide-content-padding {\n  padding: 0 !important;\n}\n\n.ant-layout-content.remove-padding {\n  padding: 0;\n}\n\n.ant-layout-content.less-padding {\n  padding: 30px 0px;\n}\n\n.DashboardContainer-container-4 {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n/* content field */\n.ant-layout-content div.Paper.Wide {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);\n  padding: 30px;\n  margin: auto;\n  max-width: 100%;\n}\n\n.ant-layout-content div.Paper.Middle {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);\n  padding: 30px;\n  margin: auto;\n  max-width: 67%;\n}\n.ant-layout-content div.Paper.Narrow {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);\n  padding: 30px;\n  margin: auto;\n  max-width: 480px;\n}\n\n.job-set .ant-modal-content .ant-modal-body,\n.skill-set .ant-modal-content .ant-modal-body {\n  max-height: 600px;\n  overflow-y: auto;\n}\n\n.moreTestTable .ant-table .ant-table-thead > tr > th {\n  padding: 16px 4px;\n}\n\n.contentColumn .stretcher.leftDrawerCollapsed {\n  display: block;\n}\n\n/* --- Updates made along with \"New user profile\" project, 2019/08/02 - 2019-08/21 */\n\n.Paper.Profile-Box {\n  min-height: auto !important;\n  margin-bottom: 24px;\n  position: relative;\n}\n.Paper.Card {\n  min-height: auto !important;\n  margin-bottom: 0;\n  position: relative;\n}\n\n.Paper .title-1 {\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 26px;\n  text-align: left;\n  color: #212121;\n}\n\n.Paper .content {\n  padding-top: 40px;\n  padding-bottom: 40px;\n}\n\n.Paper .content.centered {\n  text-align: center;\n}\n\n.profile-img-holder {\n  margin-bottom: 32px;\n  position: relative;\n}\n\n.profile-img-avatar-container {\n  display: inline-block;\n  position: relative;\n}\n\n.profile-img-avatar-container button.edit {\n  top: -20px;\n  right: -20px;\n  border: none;\n  background: transparent;\n  opacity: 0;\n  transition: 0.5s opacity ease;\n}\n\n.profile-img-avatar-container button.edit:hover {\n  background: transparent;\n}\n\n.profile-img-avatar-container:hover button.edit {\n  opacity: 1;\n}\n\n.profile-img-loading {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.8);\n  opacity: 1;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 3;\n  font-size: 2em;\n}\n\n.profile-img {\n  width: 96px;\n  height: 96px;\n  margin: 0 auto;\n  border-radius: 100%;\n  cursor: pointer;\n}\n\n.profile-img-edit-menu {\n  padding: 0;\n  margin: 0;\n}\n\n.profile-img-edit-menu li {\n  width: 100%;\n  padding: 5px 10px;\n  list-style: none;\n  cursor: pointer;\n}\n\n.profile-img-edit-menu li:hover {\n  background: rgba(24, 144, 255, 0.1);\n}\n\n.profile-img-edit-menu li .anticon {\n  margin-right: 10px;\n}\n\n.user-fullname {\n    font-weight:  600;\n  font-size: 16px;\n  line-height: 21px;\n  text-align: center;\n  color: #444444;\n  margin-bottom: 16px;\n}\n\n.user-title {\n  font-weight:  600;\n  font-size: 14px;\n  line-height: 19px;\n  text-align: center;\n  color: #666666;\n  margin-bottom: 8px;\n}\n\n.user-subtitle {\n  font-weight:  300;\n  font-size: 12px;\n  line-height: 16px;\n  text-align: center;\n  color: #888888;\n  margin-bottom: 8px;\n}\n\n.user-address {\n  margin-top: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  color: #666666;\n}\n.user-address span.txt {\n  margin-left: 7px;\n}\n\n.user-worktime {\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  color: #666666;\n}\n\n.user-linkedin {\n  font-weight:  300;\n  font-size: 12px;\n  line-height: 16px;\n  text-align: center;\n  margin-top: 8px;\n  color: #666666;\n}\n\n.user-github {\n  font-weight:  300;\n  font-size: 12px;\n  line-height: 16px;\n  text-align: center;\n  margin-top: 8px;\n  color: #666666;\n}\n\n.user-worktime span.txt {\n  margin-left: 7px;\n}\n\n.user-working-hours {\n  margin-bottom: 10px;\n}\n\n.input-name .user-timezone,\n.input-name .pacific-timezone {\n  font-size: 11px;\n  display: block;\n  opacity: 0.6;\n}\n\n.user-time-overlap {\n  font-size: 0.8em;\n}\n\n.user-time-overlap .good-overlap {\n  color: #28a745;\n}\n\n.user-time-overlap .bad-overlap {\n  color: #dc3545;\n}\n\n.user-time-overlap-popover {\n  font-size: 12px;\n  line-height: 2em;\n}\n\n.upload-file-btn-holder {\n  margin-top: 20px;\n}\n\n.upload-file-btn-holder .upload-file-name {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #888;\n}\n\n.upload-file-btn-holder .upload-file-name a {\n  color: inherit;\n  font-size: 13px;\n}\n\n.experience,\n.projects,\n.education,\n.cert-aw,\n.publication {\n  position: relative;\n  display: flex;\n  margin-bottom: 30px;\n  align-items: center;\n}\n\n.experience:last-child,\n.projects:last-child,\n.education:last-child,\n.cert-aw:last-child,\n.publication:last-child {\n  margin-bottom: 0;\n}\n\n.experience .e-date-holder,\n.projects .e-date-holder,\n.education .e-date-holder,\n.cert-aw .e-date-holder,\n.publication .e-date-holder {\n  /*width: 15%;\n        min-width: 80px;\n        display: inline-block;*/\n  height: auto;\n  min-height: 100%;\n  /*height: calc(100% - 40px - 40px);*/\n  min-width: 63px;\n}\n\n.experience .e-date-holder .e-date-end,\n.projects .e-date-holder .e-date-end,\n.education .e-date-holder .e-date-end,\n.cert-aw .e-date-holder .e-date-end,\n.publication .e-date-holder .e-date-end {\n}\n\n.experience .e-date-holder .e-date-start,\n.projects .e-date-holder .e-date-start,\n.education.e-date-holder .e-date-start,\n.cert-aw .e-date-holder .e-date-start,\n.publication .e-date-holder .e-date-start {\n}\n\n.experience .e-date-holder .e-date-separator,\n.projects .e-date-holder .e-date-separator,\n.education .e-date-holder .e-date-separator,\n.cert-aw .e-date-holder .e-date-separator,\n.publication .e-date-holder .e-date-separator {\n  margin: 0 auto;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  width: 1px;\n  height: 100%; /* IE support */\n  height: calc(100% - 120px);\n  min-height: 10px;\n  background-color: rgb(230, 230, 230);\n}\n\n.experience .e-date-holder .e-date-month,\n.projects .e-date-holder .e-date-month,\n.education .e-date-holder .e-date-month,\n.cert-aw .e-date-holder .e-date-month,\n.publication .e-date-holder .e-date-month {\n    font-weight:  600;\n  font-size: 12px;\n  line-height: 16px;\n  text-align: left;\n  color: #888888;\n}\n\n.experience .e-date-holder .e-date-year,\n.projects .e-date-holder .e-date-year,\n.education .e-date-holder .e-date-year,\n.cert-aw .e-date-holder .e-date-year,\n.publication .e-date-holder .e-date-year {\n    font-weight:  600;\n  font-size: 16px;\n  line-height: 21px;\n  text-align: left;\n  color: #888888;\n}\n\n.experience .e-content-holder,\n.projects .e-content-holder,\n.education .e-content-holder,\n.cert-aw .e-content-holder,\n.publication .e-content-holder {\n  /*width: 85%;*/\n  display: inline-block;\n  margin-left: 20px;\n}\n\n.experience .e-title-holder,\n.projects .e-title-holder,\n.education .e-title-holder,\n.cert-aw .e-title-holder,\n.publication .e-title-holder {\n}\n\n.experience .e-title,\n.projects .e-title,\n.education .e-title,\n.cert-aw .e-title,\n.publication .e-title {\n    font-weight:  600;\n  font-size: 14px;\n  line-height: 19px;\n  text-align: left;\n  color: #212121;\n  margin-bottom: 2px;\n}\n\n.experience .e-subtitle,\n.projects .e-subtitle,\n.education .e-subtitle,\n.cert-aw .e-subtitle,\n.publication .e-subtitle {\n  font-weight:  300;\n  font-size: 12px;\n  line-height: 16px;\n  text-align: left;\n  color: #888888;\n  margin-bottom: 2px;\n}\n\n.experience .e-details-holder,\n.projects .e-details-holder {\n  font-weight:  300;\n  font-size: 14px;\n  line-height: 21px;\n  text-align: left;\n  color: #212121;\n  margin-bottom: 5px;\n}\n\n.experience .e-details-holder ul,\n.projects .e-details-holder ul {\n  padding: 0;\n  padding-left: 20px;\n  padding-top: 20px;\n  margin: 0;\n}\n\n.experience .e-details-holder ul li,\n.projects .e-details-holder ul li {\n  font-weight:  300;\n  font-size: 14px;\n  line-height: 21px;\n  text-align: left;\n  color: #212121;\n  margin-bottom: 5px;\n}\n\n.Paper .experience,\n.Paper .projects {\n  padding-right: 20px;\n}\n\n.experience .edit-btn,\n.projects .edit-btn {\n  position: absolute;\n  top: 0;\n  right: 24px;\n  opacity: 0;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n\n.cert-aw .edit-btn,\n.publication .edit-btn {\n  position: absolute;\n  top: -18px;\n  right: 24px;\n  opacity: 0;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n\n.experience .edit-btn,\n.projects .edit-btn,\n.cert-aw .edit-btn,\n.publication .edit-btn {\n  opacity: 0;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n\n.experience:hover .edit-btn,\n.projects:hover .edit-btn,\n.cert-aw:hover .edit-btn,\n.publication:hover .edit-btn {\n  opacity: 1;\n  right: 39px;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n\n.experience .delete-btn,\n.projects .delete-btn {\n  position: absolute;\n  top: 0;\n  right: -28px;\n  opacity: 0;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n\n.cert-aw .delete-btn,\n.publication .delete-btn {\n  position: absolute;\n  top: -18px;\n  right: -28px;\n  opacity: 0;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n\n.experience .delete-btn,\n.projects .delete-btn,\n.cert-aw .delete-btn,\n.publication .delete-btn {\n  opacity: 0;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n\n.experience:hover .delete-btn,\n.projects:hover .delete-btn,\n.cert-aw:hover .delete-btn,\n.publication:hover .delete-btn {\n  opacity: 1;\n  right: -13px;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n\ntable.skills-table,\ntable.jobs-table {\n  width: 100%;\n  border: none;\n}\n\ntable.skills-table thead,\ntable.jobs-table thead {\n}\n\ntable.skills-table {\n  margin-top: 30px;\n}\n\nbutton.ant-btn.ant-btn-primary[disabled] {\n  background-color: #ededed;\n  color: #999999;\n}\n\n.Paper .skills-bottom .ant-typography {\n  display: block;\n}\n\ntable.skills-table thead tr th,\ntable.jobs-table thead tr th {\n    font-weight:  600;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.5);\n  text-align: left;\n  line-height: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #e8e8e8;\n}\n\ntable.skills-table tbody tr td {\n  vertical-align: top;\n}\n\ntable.skills-table .ant-form-item {\n  margin-bottom: 0 !important;\n}\n\n.skills-table tbody tr td i.anticon-delete {\n  color: red;\n  font-size: 16px;\n  margin: 12px 0px;\n}\n\ntable.skills-table thead tr th:nth-child(1) {\n  max-width: 30%;\n  min-width: 30%;\n  width: 30% !important;\n  text-align: left;\n}\ntable.skills-table thead tr th:nth-child(2) {\n  max-width: 25%;\n  min-width: 25%;\n  width: 25% !important;\n  text-align: left;\n  padding-left: 10px;\n}\ntable.skills-table thead tr th:nth-child(3) {\n  max-width: 25%;\n  min-width: 25%;\n  width: 25% !important;\n  text-align: left;\n  padding-left: 10px;\n}\ntable.skills-table thead tr th:nth-child(4) {\n  text-align: right;\n}\n\ntable.jobs-table thead tr th:nth-child(1) {\n  text-align: left;\n  max-width: 80px;\n  word-wrap: break-word;\n}\n\ntable.jobs-table thead tr th:nth-child(2) {\n  text-align: left;\n  padding-left: 10px;\n}\n\ntable.jobs-table thead tr th:nth-child(3) {\n  text-align: right;\n}\n\ntable.skills-table tbody,\ntable.jobs-table tbody {\n}\n\ntable.skills-table tbody tr,\ntable.jobs-table tbody tr {\n  background-color: transparent;\n}\n\ntable.skills-table tbody tr:hover td .button-holder {\n  opacity: 1;\n  right: 15px;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n\ntable.skills-table tbody tr td,\ntable.jobs-table tbody tr td {\n  font-weight:  300;\n  font-size: 14px;\n  color: #212121;\n  text-align: left;\n  line-height: 22px;\n  border-bottom: 1px solid #e8e8e8;\n  padding: 13px 0;\n}\ntable.skills-table tbody tr td:nth-child(1),\ntable.jobs-table tbody tr td:nth-child(1) {\n  text-align: left;\n  max-width: 80px;\n  word-wrap: break-word;\n}\ntable.skills-table tbody tr td:nth-child(2),\ntable.jobs-table tbody tr td:nth-child(2) {\n  text-align: left;\n  padding-left: 10px;\n}\ntable.skills-table tbody tr td:nth-child(3) {\n  text-align: left;\n  padding-left: 10px;\n}\ntable.jobs-table tbody tr td:nth-child(3) {\n  text-align: right;\n  position: relative;\n}\ntable.skills-table tbody tr td:nth-child(4) {\n  text-align: right;\n  position: relative;\n}\n\ntable.skills-table tbody tr td .button-holder {\n  width: 110px;\n  position: absolute;\n  top: 0;\n  right: -2px;\n  opacity: 0;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n\ntable.skills-table tbody tr td .button-holder button {\n  /*width: 35px !important;\n            height: 35px !important;*/\n}\ntable.skills-table tbody tr td .button-holder button:nth-child(1) {\n  margin-right: 7px;\n}\n\n.ant-select-selection:hover {\n  border-color: #888888 !important;\n  box-shadow: 0 1px 2px rgba(136, 136, 136, 0.16) !important;\n}\n.ant-select-selection:focus {\n  border: 1px solid #42a5f5 !important;\n  box-shadow: 0 1px 2px rgba(66, 165, 245, 0.2) !important;\n}\n\nbutton.edit {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n}\n\n.select-search-holder {\n  position: relative;\n  width: 100%;\n}\n\n.select-search-holder {\n  position: relative;\n  width: 100%;\n}\n\n.select-search-holder .material-icons {\n  position: absolute;\n  top: 7px;\n  left: 5px;\n  z-index: 99;\n}\n\n.select-search-holder .ant-select-selection {\n  padding-left: 20px;\n}\n\n.select-search-holder .ant-select-selection .ant-select-arrow {\n  display: none;\n}\n\n.ant-select.error .ant-select-selection {\n  background-color: #ffffff;\n  border: 1px solid #ef5350 !important;\n  box-shadow: 0 0 0 transparent !important;\n}\n\n.modal-wrap {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(245, 245, 245, 0.55);\n  z-index: 200;\n}\n\n.modal-wrap .modal-wrap-inner {\n  position: relative;\n  top: 0;\n  left: 0;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.modal-wrap .modal-wrap-inner .modal-box {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 70%;\n  min-width: 300px;\n  max-width: 750px;\n  height: auto;\n  min-height: 300px;\n  margin: 0 auto;\n  transform: translate(-50%, -50%);\n  background-color: #ffffff;\n  border-radius: 4px;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.08);\n}\n\n.modal-wrap .modal-wrap-inner .modal-box .modal-box-close {\n  position: relative;\n}\n\n.modal-wrap .modal-wrap-inner .modal-box .modal-box-close button {\n  position: absolute;\n  top: 32px;\n  right: 32px;\n}\n\n.modal-wrap .modal-wrap-inner .modal-box .modal-header {\n}\n\n.modal-wrap .modal-wrap-inner .modal-box .modal-header .modal-title {\n    font-weight:  600;\n  font-size: 28px;\n  color: #212121;\n  text-align: left;\n  line-height: 37px;\n  margin: 48px 32px 32px 32px;\n}\n\n.modal-wrap .modal-wrap-inner .modal-box .modal-body {\n  padding: 0 32px;\n}\n\n.modal-body-row,\n.modal-wrap .modal-wrap-inner .modal-box .modal-body .modal-body-row {\n  margin-bottom: 20px;\n}\n\n.modal-body-row .modal-body-col-5050 {\n  width: 50%;\n  display: inline-block;\n}\n.modal-body-row .modal-body-col-5050:nth-child(1) {\n  padding-right: 10px;\n}\n.modal-body-row .modal-body-col-5050:nth-child(2) {\n  padding-left: 10px;\n}\n\n.modal-body-row .modal-body-col-5050.multiple-selects .ant-select {\n  margin-bottom: 7px;\n}\n\n.modal-body-row .modal-body-col-75 {\n  width: 75%;\n  display: inline-block;\n  padding-right: 10px;\n}\n.modal-body-row .modal-body-col-25 {\n  width: 25%;\n  display: inline-block;\n}\n\n.modal-wrap .modal-wrap-inner .modal-box .modal-footer {\n  display: flex;\n  justify-content: right;\n  padding: 32px 32px 24px 32px;\n}\n\n.modal-wrap .modal-wrap-inner .modal-box .modal-footer button:not(:last-child) {\n  margin-right: 8px;\n}\n\n@media (max-width: 1023px) {\n  .profile-section {\n    justify-content: center;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .modal-body-row .modal-body-col-5050 {\n    width: 100%;\n    display: block;\n    margin: 15px 0px;\n  }\n\n  .modal-body-row {\n    margin-bottom: 0px;\n  }\n  .modal-body-row .modal-body-col-5050:nth-child(1) {\n    padding-right: 0px;\n  }\n  .modal-body-row .modal-body-col-5050:nth-child(2) {\n    padding-left: 0px;\n  }\n\n  .ant-layout .ant-layout-content {\n    padding: 120px 10px 20px;\n    margin: 0 !important;\n    display: flex;\n    /* justify-content: center; */\n    max-width: 100vw !important;\n  }\n\n  .detailsSection {\n    width: 90vw !important;\n  }\n\n  .title-1 {\n    font-size: 17px !important;\n  }\n  .ant-layout-content.remove-padding {\n    padding: 64px 0 0 0 !important;\n    margin: 0 !important;\n  }\n\n  .ant-layout-content.less-padding {\n    padding: 100px 10px !important;\n    margin: 0 !important;\n  }\n}\n\n@media (max-width: 744px) {\n .ant-layout .ant-layout-content {\n    padding: 80px 10px 20px;\n  }\n}\n\n/*.ant-modal-wrap, .ant-modal-wrap > *{\n    transition: all 0.2s;\n  }\n  \n  .ant-modal-wrap, .ant-modal-wrap > *{\n    transition: all 0.2s;\n  }*/\n\n.present-date {\n  /*display: none;*/\n    font-weight:  600;\n  font-size: 16px;\n  line-height: 21px;\n  text-align: left;\n  color: #888888;\n}\n.present-date.visible {\n  display: block;\n}\n\n.end-date-selects {\n}\n.end-date-selects.hidden {\n  display: none;\n}\n\n.ant-btn.ant-btn-danger {\n  color: #fff;\n  background-color: #ff4d4f;\n  border-color: #ff4d4f;\n}\n.ant-btn.ant-btn-danger:hover,\n.ant-btn.ant-btn-danger:focus {\n  color: #fff !important;\n  background-color: #ff7875 !important;\n  border-color: #ff7875;\n}\n.ant-btn.ant-btn-danger:active {\n  color: #fff !important;\n  background-color: #d9363e !important;\n  border-color: #d9363e;\n}\n\n.is-white-c {\n  color: #ffffff;\n}\n\n.is-visible {\n  display: block;\n}\n.is-hidden {\n  display: none;\n}\n.is-block {\n  display: block;\n}\n.is-inlineb {\n  display: inline-block;\n}\n.is-inline {\n  display: inline;\n}\n\n.is-left {\n  float: left;\n}\n.is-right {\n  float: right;\n}\n\n.is-flex {\n  display: flex;\n}\n\n.flex-center-content {\n  display: flex;\n  align-items: center;\n}\n\n.info-btn {\n  margin-left: 7px;\n}\n\n.ant-alert {\n  margin-bottom: 16px;\n}\n\n/* DEFAULT CHECKBOX */\n\n.ant-checkbox-wrapper {\n  margin-bottom: 4px;\n}\n\n.ant-checkbox {\n  position: relative;\n  z-index: 2 !important;\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n}\n\n.ant-checkbox::after {\n  top: 11px;\n  left: 11px;\n}\n\n.ant-checkbox input.ant-checkbox-input {\n  z-index: 0 !important;\n}\n\n.ant-checkbox .ant-checkbox-inner {\n  top: 11px;\n  left: 11px;\n  width: 18px;\n  height: 18px;\n  border: 2px solid #888888 !important;\n  background-color: transparent;\n}\n\n/* on Focus */\n\n.ant-checkbox-wrapper:focus-within .ant-checkbox {\n  /*background-color: rgba(68, 68, 68, 0.12) !important;*/\n  background-color: transparent;\n}\n.ant-checkbox:focus-within,\n.ant-checkbox.ant-checkbox-checked:focus-within {\n  /*background-color: rgba(68, 68, 68, 0.12) !important;*/\n  background-color: transparent;\n}\n\n/*\n  How Ant handles focus and active state\n  -\n  .ant-checkbox-input:focus + .ant-checkbox-inner {\n    background-color: rgba(68, 68, 68, 0.12) !important;\n  -\n  We will have to make something around this styling logic to get our design\n  The problem here is that Ant puts focus on input and styles alement next to it,\n  but we want to style parent element.\n  }*/\n\n.ant-checkbox-wrapper:focus .ant-checkbox-inner {\n  border: 2px solid #888888;\n}\n\n/* on Click */\n\n.ant-checkbox-wrapper:active .ant-checkbox,\n.ant-checkbox:active,\n.ant-checkbox-wrapper .ant-checkbox.ant-checkbox-checked:active {\n  background-color: rgba(68, 68, 68, 0.18) !important;\n}\n\n.ant-checkbox-wrapper:active .ant-checkbox-inner {\n  border: 2px solid #888888;\n}\n\n/* Checked */\n\n.ant-checkbox.ant-checkbox-checked .ant-checkbox-inner {\n  background-color: #444444;\n  border: 2px solid #444444 !important;\n}\n\n.ant-checkbox.ant-checkbox-checked::after {\n  border: none;\n  animation: none;\n}\n\n/* Hover */\n\n.ant-checkbox:hover {\n  background-color: rgba(68, 68, 68, 0.06) !important;\n}\n\n.ant-checkbox:hover .ant-checkbox-inner {\n  /*border: 2px solid #888888 !important;*/\n}\n\n/* Disabled */\n\n.ant-checkbox-wrapper-disabled .ant-checkbox-disabled {\n  background-color: transparent !important;\n}\n\n.ant-checkbox-wrapper-disabled\n  .ant-checkbox-disabled.ant-checkbox-checked\n  .ant-checkbox-inner {\n  background-color: #aaaaaa !important;\n  border: 2px solid #aaaaaa !important;\n}\n\n.ant-checkbox-wrapper-disabled .ant-checkbox-disabled .ant-checkbox-inner {\n  border: 2px solid #aaaaaa !important;\n}\n\n.ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {\n  border-color: #fff !important;\n}\n\n/* INDETERMINATE */\n\n.ant-checkbox.ant-checkbox-indeterminate {\n  /*background-color: transparent !important;*/\n}\n\n/* Checked */\n\n.ant-checkbox.ant-checkbox-indeterminate .ant-checkbox-inner {\n  border: 2px solid #888888 !important;\n}\n\n.ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-checked\n  .ant-checkbox-inner {\n  background-color: transparent !important;\n}\n\n.ant-checkbox.ant-checkbox-indeterminate .ant-checkbox-inner::after {\n  background-color: transparent;\n}\n\n.ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-checked\n  .ant-checkbox-inner::after {\n  background-color: #444444;\n}\n\n/* Disabled */\n\n.ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-disabled\n  .ant-checkbox-inner {\n  border: 2px solid #aaaaaa !important;\n}\n\n.ant-checkbox.ant-checkbox-indeterminate.ant-checkbox-disabled\n  .ant-checkbox-inner::after {\n  background-color: #aaaaaa !important;\n}\n\n.ant-checkbox-wrapper:active .ant-checkbox.ant-checkbox-disabled {\n  background-color: transparent !important;\n}\n\n/* Hover */\n\n.ant-checkbox-wrapper:hover\n  .ant-checkbox-indeterminate.ant-checkbox-checked\n  .ant-checkbox-inner {\n  border: 2px solid #888888 !important;\n}\n\n/* WITH LABEL */\n\n.ant-checkbox-wrapper + span,\n.ant-checkbox + span {\n  font-size: 14px;\n  color: #888888;\n  /*padding-left: 0;*/\n  display: inline-block;\n  vertical-align: middle;\n  padding-bottom: 3px;\n}\n\n/* Disabled */\n\n.ant-checkbox-wrapper.ant-checkbox-wrapper-disabled + span,\n.ant-checkbox.ant-checkbox-disabled + span {\n  color: #aaaaaa;\n}\n\n/* GROUP */\n\n/* List checkboxes one under the other */\n\n.cbx-list-group {\n}\n\n.cbx-list-group .ant-checkbox-group-item {\n  display: block;\n}\n\n/* GROUP - indeterminate */\n\n.group-indeterminate {\n}\n\n.group-indeterminate > .ant-checkbox-wrapper {\n  margin-bottom: 10px;\n}\n\n.group-indeterminate .ant-checkbox-group {\n  display: block;\n  width: 100%;\n  padding-left: 23px;\n}\n\n.group-indeterminate .ant-checkbox-group .ant-checkbox-group-item {\n  display: block;\n}\n\n/* ANIMATION */\n\n.ant-checkbox.ant-checkbox-checked::after {\n  border: none;\n  animation: none;\n}\n\n/* Ant input with prefix */\n\n.ant-input-prefix input.ant-input {\n  padding-left: 30px;\n}\n\n.ant-input-prefix input.ant-input::placeholder {\n  padding-left: 30px;\n}\n\n/* AutoComplete Ant component styles */\n\n.ant-select-auto-complete.ant-select .ant-select-selection--single {\n  padding-top: 0 !important;\n}\n\n/* Ant input with prefix */\n\n.ant-input-prefix input.ant-input {\n  padding-left: 30px;\n}\n\n.ant-input-prefix input.ant-input::placeholder {\n  padding-left: 30px;\n}\n\n/* Ant input with suffix */\n\n.ant-input-affix-wrapper .ant-input-suffix {\n  color: rgba(0, 0, 0, 0.25);\n}\n\n.ant-input-suffix-black .ant-input-suffix {\n  color: rgba(0, 0, 0) !important;\n}\n\n.ant-input-suffix-black .ant-input-prefix {\n  color: rgba(0, 0, 0) !important;\n}\n\n/* AutoComplete Ant component styles */\n\n.ant-select-auto-complete.ant-select .ant-select-selection--single {\n  padding-top: 0 !important;\n}\n\n.ant-select-auto-complete.ant-select .ant-input {\n  height: 40px;\n}\n\n.ant-select.error input.ant-input {\n  border-color: transparent !important;\n}\n\n.product-design {\n  line-height: 1.8;\n}\n\n.product-design .list-title {\n  font-weight: 500;\n  margin-bottom: 7px;\n}\n\n.product-design .roman-list-style {\n  list-style-type: upper-alpha;\n  padding-left: 19px;\n}\n\n.product-design .allowed-types {\n  font-size: 10px;\n  color: #bbb;\n  margin-top: 10px;\n  font-weight: 500;\n}\n\n.product-design .upload-btn-holder {\n  margin-top: 30px;\n}\n\n.system-design {\n  line-height: 1.8;\n}\n\n.system-design .roman-list-style {\n  list-style-type: upper-alpha;\n  padding-left: 19px;\n}\n\n.system-design .list-title {\n  font-weight: 500;\n  margin-bottom: 7px;\n}\n\n.system-design .allowed-types {\n  font-size: 10px;\n  color: #bbb;\n  margin-top: 10px;\n  font-weight: 500;\n}\n\n.system-design .upload-btn-holder {\n  margin-top: 30px;\n}\n\n.skill-user-guide {\n  padding-top: 10px;\n  color: orange;\n  margin: 0px;\n  font-weight: 500;\n}\n\n/* Dropdown customization */\n/* Only override with more specific class, otherwise let it choose default width */\n.ant-select-dropdown.override-width {\n  width: 250px !important;\n}\n\n.profile-section {\n  padding-top: 30px;\n  /* padding-bottom: 30px; */\n}\n\n.profile-container {\n  max-width: 800px;\n  margin: 0px auto;\n}\n\n.experience .e-details-label {\n  padding-top: 10px;\n  padding-bottom: 5px;\n  text-decoration: underline;\n}\n\n/* Default input - placeholder */\n.ant-input::-webkit-input-placeholder {\n  color: #959595 !important;\n  opacity: 1 !important;\n}\n\n.ant-input::-moz-placeholder {\n  color: #959595 !important;\n  opacity: 1 !important;\n}\n\n.ant-input::-ms-input-placeholder {\n  color: #959595 !important;\n  opacity: 1 !important;\n}\n\n.ant-input::placeholder {\n  color: #959595 !important;\n  opacity: 1 !important;\n}\n\n.bottom-padded {\n  padding-bottom: 80px !important;\n}\n\n.promptMessage {\n  font-size: 14px;\n  color: grey;\n}\n\n.deleteSkill {\n  padding-top: 22px !important;\n  text-align: right !important;\n  cursor: pointer !important;\n}\n\n.left-aligned {\n  text-align: left !important;\n}\n\n.ant-radio-wrapper {\n  display: flex !important;\n}\n\n.ql-syntax {\n  background-color: #fafafa !important;\n  color: #426bb9 !important;\n}\n\n/* Set content font-families */\n.ql-font-Gordita {\n  font-family: \"Gordita\";\n}\n.ql-font-Menlo {\n  font-family: \"Menlo\";\n}\n.ql-font-Ringside {\n  font-family: \"Ringside\";\n}\n.ql-font-Ginto {\n  font-family: \"Ginto\";\n}\n\n\n.vetsmithContentColumn {\n  background: #F8F8F8 !important;\n}\n\n\n.vetsmithContentColumn .ant-layout-content {\n  padding: 0;\n  background: #F8F8F8;\n}\n\n.vetsmithContentColumn .ant-layout-content:has(.ant-spin) {\n  justify-content: center;\n}\n\n.vetsmithContentColumn .turing-footer {\n  background: #F8F8F8 !important;\n}\n\n.navbar-padding {\n  padding: 50px 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
